
import { defineComponent } from 'vue';
import CloseBtn from "../pageElements/CloseBtn.vue";

import TileDisplay from "./TileDisplay.vue";
import ProjectMockup from "./ProjectMockup.vue";

export default defineComponent({
    name: "ProjectModal",

    components:{
        CloseBtn,
        TileDisplay,
        ProjectMockup
    },

    props:[
        "data"
    ],

    emits:[
        "hideModals"
    ],

    data(){
        return{
            desktopMockup: false
        } 
    },

    methods:{

        scrollTopModal(){

            const innerModal = this.$refs.innerModal as HTMLElement;
            innerModal.scrollTo({
                top:0,
                behavior:"smooth"
            });
            
        }

    }

});
